import React, { useContext, useEffect, useRef } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import { PaginationComponent } from "../../components";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import PageLayout from "../../layouts/PageLayout";
import { ButtonComponent } from "../../components/elements";
import { listCustomers } from "../../APIs/CustomersRequests";
import CustomersTableComponent from "../../components/tables/CustomersTableComponent";

export default function CustomersListPage() {

    const { t } = useContext(TranslatorContext);
    const [customers, setCustomers] = React.useState([]);
    const [pagination, setPagination] = React.useState({});
    const [perPage, setPerPage] = React.useState(10);
    const [type, setType] = React.useState('');
    const [searchFilter, setSearchFilter] = React.useState('');
    const [isBlocked, setIsBlocked] = React.useState('');

     const searchFilterRef = useRef();
    const perPageRef = useRef();

    const listCustomersFunction = (page=1) => {
        listCustomers(page,perPage,searchFilter,type,isBlocked).then((res) => {
            setCustomers(res.data.data);
            setPagination(res.data.pagination);
        }).catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        searchFilterRef.current = searchFilter;
        perPageRef.current = perPage;
      }, [perPage,searchFilter]);
    
    useEffect(() => {
        listCustomersFunction();
    }, [perPage,searchFilter,type,isBlocked]);
    const thead = [t("customer_id"),t("name"), t("email"),t('type'),t("status"), t("created"), t("action")];

    useEffect(() => {
    const intervalId = setInterval(() => {
        listCustomersFunction(1,perPageRef.current,searchFilterRef.current);
    }, 10000);
    return () => clearInterval(intervalId); 
    });

    const handlePageClick = (selected) => {
        listCustomersFunction(selected.selected + 1);
    }

    const redirectToCreatePage = () => {
        window.location.href = '/customer-create';
    };
    
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('customers_list')}</h3>
                            {
                                localStorage.getItem('permissions').includes('adding company type') || localStorage.getItem('permissions').includes('adding individual type') ?
                                <ButtonComponent className="btn btn-primary m-2" onClick={redirectToCreatePage}>{ t('Create New') }</ButtonComponent>
                                : null
                            }
                        </div>
                    </div>
                </Col>
                
                <Col xl={12}>
                    <div className="mc-card">
                        
                        <Row xs={1} sm={2} xl={4}>
                            <Col>
                                <LabelFieldComponent
                                    label={t('show_by')}
                                    option={["10", "20", "50", "100"] }
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange= {(e)=>{
                                        setPerPage(e.target.value);
                                    }}
                                />
                            </Col>
                            
                            <Col>
                                <LabelFieldComponent
                                    label={t('type')}
                                    option={["All", "individual", "company"] }
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange= {(e)=>{
                                        if(e.target.value === 'All'){
                                            setType('');
                                        }
                                        else{
                                            setType(e.target.value);
                                        }
                                    }}
                                />
                            </Col>
                            <Col>
                                <LabelFieldComponent
                                    label={t('status')}
                                    option={["All", "blocked", "clear"] }
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange= {(e)=>{
                                        if(e.target.value === 'All'){
                                            setIsBlocked('');
                                        }
                                        else{
                                            setIsBlocked(e.target.value);
                                        }
                                    }}
                                />
                            </Col>
                            <Col>
                                <LabelFieldComponent
                                    type="search"
                                    label={t('search_by')}
                                    placeholder={''}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange={(e) => {
                                            setSearchFilter(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <CustomersTableComponent
                            thead={ thead }
                            tbody={ customers }
                            refreshPage={ listCustomersFunction }
                        />
                        <PaginationComponent pagination={pagination} handlePageClick={handlePageClick}/>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}